module.exports = __webpack_public_path__ + "img/20200508_163648.9f39ae17.jpg";